var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "financeApplication__form" },
    [
      _c("ValidationObserver", { ref: "observer" }, [
        _c(
          "div",
          { class: _vm.classNames },
          [
            _c("ValidationProvider", {
              attrs: {
                name: "sort code",
                rules: _vm.sortCodeValidationRules,
                slim: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    return [
                      _c(
                        "FinanceApplicationRow",
                        {
                          attrs: {
                            id: "bankSortCode",
                            label: "Sort Code",
                            "error-message": errors[0],
                          },
                        },
                        [
                          _c("FinanceApplicationText", {
                            ref: "sortCode",
                            attrs: {
                              id: "bankSortCode",
                              placeholder: "12-34-56",
                            },
                            model: {
                              value: _vm.bankSortCode,
                              callback: function ($$v) {
                                _vm.bankSortCode = $$v
                              },
                              expression: "bankSortCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("ValidationProvider", {
              attrs: {
                name: "account number",
                rules: _vm.accountNumberValidationRules,
                slim: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var errors = ref.errors
                    return [
                      _c(
                        "FinanceApplicationRow",
                        {
                          attrs: {
                            id: "bankAccountNumber",
                            label: "Account Number",
                            "error-message": errors[0],
                          },
                        },
                        [
                          _c("FinanceApplicationText", {
                            attrs: {
                              type: "number",
                              id: "bankAccountNumber",
                              placeholder: "87654321",
                            },
                            model: {
                              value: _vm.bankAccountNumber,
                              callback: function ($$v) {
                                _vm.bankAccountNumber = $$v
                              },
                              expression: "bankAccountNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm._m(0),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "financeApplication__additionalText" }, [
      _c("strong", [_vm._v("Please note.")]),
      _vm._v(" We ONLY use these details to provide you with a quote.\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }